import React from 'react';

const Pay = () => {
    return (
        <div>
            <h1>Payment method comming soon...</h1>
        </div>
    );
};

export default Pay;